(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name TypeaheadService
     *
     * @description
     * Helper services for providing a list of user and group wrappers for a typeahead and an email list.
     */
    angular.module('GorillaBoy.services')
    .factory('TypeaheadService', [
        '$http',
        '$log',
        '$q',
        '$translate',
        'authenticatedUser',
        'EndpointService',
        'OrganizationService',
        'GroupCollectionService',
        'AppConstants',
        TypeaheadService
    ]);

    function TypeaheadService ($http, $log, $q, $translate, authenticatedUser, EndpointService, OrganizationService, GroupCollectionService, AppConstants) {

        // AppConstant bindings
        var collaboratorTypes = AppConstants.CollaboratorTypes;

        var typeaheadService = {},
            prevUserCollaboratorWrappers = [],
            prevGroupCollaboratorWrappers = [],
            searchUsersCanceler = null,
            searchGroupsCanceler = null;

        // Wrap the user or the group metadata.
        function CollaboratorWrapper(type, metadata, typeaheadDisplayName, emailListDisplayName, headerDisplayName) {
            this.type = type;
            this.metadata = metadata;
            this.typeaheadDisplayName = typeaheadDisplayName;
            this.emailListDisplayName = emailListDisplayName;

            // Header information
            this.headerDisplayName = headerDisplayName;

            // Enable shouldShowHeader later only if this CollaboratorWrapper is the first item in results.
            this.shouldShowHeader = false;
            this.isFirstHeader = false;
        }

        typeaheadService.searchUsers = function (query, params) {
            var defaultParams = {
                    excludeSelf: false,
                    includeInactiveUsers: false,
                    currentUsername: null,
                    reuseLastSearchOnError: true,
                    showQueryAsMatch: true
                },
                deferred = $q.defer(),
                queryComponents = $.map(query.split(','), $.trim),
                searchQuery = null,
                filter = null;

            params = angular.extend({}, defaultParams, params);
            if (params.includeInactiveUsers) {
                filter = 'ALL';
            } else {
                filter = 'ACTIVE_PENDING';
            }

            searchQuery = queryComponents[queryComponents.length - 1];
            if (searchQuery.length === 0) {
                deferred.reject();
            }

            if (searchUsersCanceler) {
                searchUsersCanceler.resolve();
            }
            searchUsersCanceler = $q.defer();

            OrganizationService.searchOrganizationUsers({
                query: searchQuery,
                filter: filter,
                pageSize: 5
            }, searchUsersCanceler.promise)
            .then(function (response) {
                var data = response.data;
                var userCollaboratorWrappers = [];

                angular.forEach(data.Users, function(user) {
                    if (!params.excludeSelf || (user.Id !== authenticatedUser.getUserInfo().Id)) {
                        var typeaheadDisplayName = null,
                            emailListDisplayName = null;

                        if (!user.GivenName) {
                            // Display the email if the user does not have a given name
                            typeaheadDisplayName = user.Username;
                            emailListDisplayName = typeaheadDisplayName;
                        } else {
                            // Display the user's name as a concatenation of given name surname and user name
                            emailListDisplayName = user.GivenName + ' ' + user.Surname;
                            typeaheadDisplayName = emailListDisplayName + ' (' + user.Username + ')';
                        }

                        if (typeaheadDisplayName) {
                            userCollaboratorWrappers.push(new CollaboratorWrapper(
                                collaboratorTypes.USER,
                                user,
                                typeaheadDisplayName,
                                emailListDisplayName,
                                $translate.instant('MODAL.SHARE_MODAL.HEADER_USERS')
                            ));
                        }
                    }
                });

                // showQueryAsMatch will determine whether or not a query will be considered as a match
                if (userCollaboratorWrappers.length === 0) {
                    var anonymousMetadata = {
                        GivenName: query,
                        Surname: '',
                        Username: query
                    };

                    if (params.showQueryAsMatch) {
                        // When creating the permission, always pass an unknown user as INVITE.
                        // The service will determine whether the user is an ANONYMOUS share or
                        // the user needs to be created.
                        userCollaboratorWrappers.push(new CollaboratorWrapper(
                            collaboratorTypes.INVITE,
                            anonymousMetadata,
                            query,
                            query,
                            null
                        ));
                    } else {
                        userCollaboratorWrappers.push(new CollaboratorWrapper(
                            null,
                            anonymousMetadata,
                            $translate.instant('GENERAL_MESSAGES.NO_RESULTS_FOUND'),
                            query,
                            null
                        ));
                    }
                } else {
                    // Enable the shouldShowHeader property of the first collaborator wrapper.
                    userCollaboratorWrappers[0].shouldShowHeader = true;
                }

                prevUserCollaboratorWrappers = userCollaboratorWrappers;
                deferred.resolve(prevUserCollaboratorWrappers);
            }, function (error) {
                if (prevUserCollaboratorWrappers) {
                    deferred.resolve(prevUserCollaboratorWrappers);
                } else {
                    deferred.reject(error);
                }
            });

            return deferred.promise;
        };

        typeaheadService.searchGroups = function (query) {
            var deferred = $q.defer(),
                queryComponents = $.map(query.split(','), $.trim),
                searchQuery = queryComponents[queryComponents.length - 1];

            if (searchQuery.length === 0) {
                deferred.reject([]);
            }

            if (searchGroupsCanceler) {
                searchGroupsCanceler.resolve();
            }
            searchGroupsCanceler = $q.defer();

            GroupCollectionService.searchGroupCollection({
                query: searchQuery,
                vendor: 'DIRECTORY_SERVICE',
                pageSize: 5,
            }, searchGroupsCanceler.promise)
            .then(function (response) {
                var res = response.data;
                var groups = angular.fromJson(res).Groups,
                    groupCollaboratorWrappers = [];

                angular.forEach(groups, function(group) {
                    groupCollaboratorWrappers.push(new CollaboratorWrapper(
                        collaboratorTypes.GROUP,
                        group,
                        group.Name,
                        group.Name,
                        $translate.instant('MODAL.SHARE_MODAL.HEADER_GROUPS')
                    ));
                });

                if (groupCollaboratorWrappers.length > 0) {
                    // Enable the shouldShowHeader property of the first collaborator wrapper.
                    groupCollaboratorWrappers[0].shouldShowHeader = true;
                }

                prevGroupCollaboratorWrappers = groupCollaboratorWrappers;
                deferred.resolve(groupCollaboratorWrappers);
            }, function (error) {
                if (prevGroupCollaboratorWrappers) {
                    deferred.resolve(prevGroupCollaboratorWrappers);
                } else {
                    deferred.reject(error);
                }
            });

            return deferred.promise;
        };

        return typeaheadService;
    }
}(angular));
